var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrometheus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 116 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7 0.699997C25.4 0.699997 0 26 0 57.3C0 88.6 25.4 114 56.7 114C88 114 113.4 88.6 113.4 57.3C113.3 26 88 0.699997 56.7 0.699997Z",
    fill: "#E6522C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7 106.7C47.8 106.7 40.6 100.8 40.6 93.4H72.8C72.8 100.8 65.6 106.7 56.7 106.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3 89H30V79.4H83.3V89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1 74.4H30.2C30 74.2 29.8 74 29.7 73.8C24.2 67.2 23 63.7 21.7 60.2C21.7 60.1 28.3 61.6 33 62.6C33 62.6 35.4 63.2 39 63.8C35.6 59.8 33.6 54.8 33.6 49.6C33.6 38.2 42.3 28.3 39.2 20.3C42.3 20.5 45.5 26.8 45.8 36.5C49.1 32 50.4 23.8 50.4 18.8C50.4 13.6 53.8 7.5 57.3 7.3C54.2 12.3 58.1 16.7 61.5 27.4C62.8 31.4 62.6 38.2 63.6 42.5C63.9 33.6 65.5 20.5 71.1 16C68.6 21.7 71.5 28.8 73.4 32.2C76.6 37.7 78.5 41.9 78.5 49.7C78.5 55 76.5 60 73.3 63.8C77 63.1 79.6 62.5 79.6 62.5L91.8 60.1C91.7 60.2 89.9 67.4 83.1 74.4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.3,
    height: 114,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrometheus);
export default __webpack_public_path__ + "static/media/prometheus.84d246a33d01578955f3fc2237f9ec7a.svg";
export { ForwardRef as ReactComponent };